// WP-15 — Placeholder HONESTO para las 9 secciones de admin que son D5-D6 (REQ-129..137).
// NO son mocks: muestran un estado vacío claro con la referencia del REQ pendiente. Todas
// navegables desde el shell (criterio REQ-126: "11 secciones navegables sin iframe").
import { useTranslation } from 'react-i18next';
import { AdminSection } from './adminShared';

interface Props {
  titleKey: string;
  descKey: string;
  req: string;
  icon: string;
}

export function AdminPlaceholder({ titleKey, descKey, req, icon }: Readonly<Props>) {
  const { t } = useTranslation('recognition');
  return (
    <AdminSection title={t(titleKey)} description={t(descKey)}>
      <div className="adm-placeholder">
        <i className={`fas ${icon}`} aria-hidden="true" />
        <p className="adm-placeholder-title">{t('admin.placeholder.soon')}</p>
        <p className="adm-placeholder-req">{t('admin.placeholder.tracked', { req })}</p>
      </div>
    </AdminSection>
  );
}

export default AdminPlaceholder;
